module.exports = "/virtual-football-league/img/amblems/right/logos/Arsenal.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Arsenal.png
// module id = 2155
// module chunks = 4